const SOCKET_EVENTS = {
  CONNECTION: "connection",
  DISCONNECT: "disconnect",
  LOGIN_USER: "login_user",
  LOGOUT_USER: "logout_user",
  ERROR_MESSAGE: "error_message",
  LOAD_ALL_GROUP_CHATS_REQUEST: "load_all_group_chats_request",
  LOAD_ALL_GROUP_CHATS_RESULT: "load_all_group_chats_result",
  LOAD_USER_CHATS_REQUEST: "load_user_chats_request",
  LOAD_USER_CHATS_RESULT: "load_user_chats_result",
  JOIN_A_ROOM_REQUEST: "join_a_room_request",
  JOIN_A_ROOM_RESULT: "join_a_room_result",
  CREATE_GROUP_ROOM_REQUEST: "create_group_room_request",
  CREATE_GROUP_ROOM_RESULT: "create_group_room_result",
  SEND_MESSAGE: "send_message",
  NEW_MESSAGE: "new_message",
  SEARCH_DATA_REQUEST: "search_data_request",
  SEARCH_DATA_RESULT: "search_data_result",
  UPDATED_ONLINE_STATUS: "updated_online_status",
  UPDATED_ROOM_PARTICIPANT: "updated_room_participant",
  USER_ONLINE_STATUS_REQUEST: "user_online_status_request",
  USER_ONLINE_STATUS_RESULT: "user_online_status_result",
  BAN_USER_IN_GROUP_ROOM_STATUS_RESULT: "ban_user_in_group_room_status_result",
  BAN_USER_TOOLBOX_IN_GROUP_ROOM_STATUS_RESULT:
    "ban_user_toolbox_in_group_room_status_result",
  USER_MODERATORSHIP_IN_GROUP_ROOM_STATUS_RESULT:
    "user_moderatorship_in_group_room_status_result",
  KICK_USER_OUT_OF_GROUP_ROOM_STATUS_RESULT:
    "kick_user_out_of_group_room_status_result",
  JOIN_ROOM_ADMIN_STATUS_REQUEST: "join_room_admin_status_request",
  JOIN_ROOM_ADMIN_STATUS_RESULT: "join_room_admin_status_result",
  JOIN_ROOM_ADMIN_FINALE_RESULT: "join_room_admin_finale_result",
  MESSAGE_DELETED_RESULT: "message_deleted_result",
  MESSAGE_EDITED_RESULT: "message_edited_result",
  MESSAGE_INTERACTION_RESULT: "message_interaction_result",
  MESSAGE_TIPPING_RESULT: "message_tipping_result",
  ROOM_TEAM_SCORE_RESULT: "room_team_score_result",
  UPDATED_USER_DATA: "updated_user_data",
  AUTO_UPDATED_ROOM_TEAM_SCORE: "auto_updated_room_team_score",
  USER_JOINED_GROUP_ROOM: "user_joined_group_room",
  USER_CONNECTED_IN_GROUP_ROOM: "user_connected_in_group_room",
  USER_DISCONNECTED_IN_GROUP_ROOM: "user_disconnected_in_group_room",
  SHUFFLE_VIDEO_CALL_IN_ROOM: "shuffle_video_call_in_room",
  SEND_EMOJI_REACTION_IN_GROUP_ROOM: "send_emoji_reaction_in_group_room",
  SEND_TOOLBOX_SCREENSHOT_IN_GROUP_ROOM:
    "send_toolbox_screenshot_in_group_room",
  UPDATE_EXPIRED_ROOM: "update_expired_room",
  EXTENDED_ROOM_EXPIRATION_TIME: "extended_room_expiration_time",
  SCREENSHOT_REACTION_UPDATE: "screen_reaction_update",
  GET_SCREENSHOT_REACTIONS: "get_screen_reactions",
  SCREENSHOT_EXPIRED: "screenshot_expired",
  SPECTATOR_VOTE: "spectator_vote",
  USER_ACTIVITY_UPDATE: "user_activity_update",

  SESSION_TERMINATED: "session_terminated",
  SESSION_TERMINATED_ACK: "session_terminated_ack",

  NEW_NOTIFICATION_BROADCAST: "new_notification_broadcast",
  UNREAD_NOTIFICATION_COUNT_UPDATE: "unread_notification_count_update",
  NOTIFICATION_DELETED_BROADCAST: "notification_deleted_broadcast",
  USER_PROFILE_UPDATED: "user_profile_updated",

  // Bookmark events
  ROOM_BOOKMARKED: "room_bookmarked",
  ROOM_UNBOOKMARKED: "room_unbookmarked",

  // Message UI enhancements
  USER_TYPING: "user_typing",
  MESSAGE_REACTION: "message_reaction",
  MESSAGE_REACTION_UPDATE: "message_reaction_update",

  // Read receipts
  MARK_MESSAGES_READ: "mark_messages_read",
  MESSAGES_READ_UPDATE: "messages_read_update",

  // Disappearing messages
  SET_DISAPPEARING: "set_disappearing",
  DISAPPEARING_UPDATED: "disappearing_updated",
  MESSAGE_EXPIRED: "message_expired",

  // Admin join request lifecycle
  JOIN_REQUESTS_EXPIRED: "join_requests_expired",
  JOIN_REQUEST_CANCELLED_BY_USER: "join_request_cancelled_by_user",

  // Block-period messages (sent while blocked — visible only to sender, never delivered)
  MESSAGE_BLOCKED: "message_blocked",

  // Keep / unkeep notifications for disappearing messages
  MESSAGE_KEPT_NOTICE: "message_kept_notice",

  // Tip notice (visible to both tipper and message owner as an in-chat system notice)
  TIP_NOTICE: "tip_notice",

  // Periodic client ping to keep last_seen accurate and detect frozen tabs
  USER_HEARTBEAT: "user_heartbeat",
};

export default SOCKET_EVENTS;
